import t from './t'

export const DECIMAL_PLACES = 2

// TODO: Consider adding number for numeric timestamps.
type DateFormattable = Date | string | undefined

const normalize = (n: number) => ('0' + n).slice(-2)

const ensureValidDate = (date?: DateFormattable): Date | undefined => {
    if (!date) return undefined
    if (typeof date === 'string') date = new Date(date)
    if (date.getTime() <= 0) return undefined
    // The literal 'Invalid Date' string is used by dates that cannot provide a valid format.
    if (date.toString() === 'Invalid Date') return undefined
    return date
}

export const formatDate = (date?: DateFormattable) => {
    date = ensureValidDate(date)
    if (!date) return ''

    const day = normalize(date.getDate())
    const month = normalize(date.getMonth() + 1)
    const year = date.getFullYear()

    return `${day}/${month}/${year}`
}

export const formatDateTime = (date?: DateFormattable) => {
    date = ensureValidDate(date)
    if (!date) return ''

    const dateFormat = formatDate(date)

    const hours = normalize(date.getHours())
    const minutes = normalize(date.getMinutes())
    const seconds = normalize(date.getSeconds())

    return `${dateFormat}, ${hours}:${minutes}:${seconds}`
}

/**
 * Ensure VAT number conforms to an exclusively numeric format.
 */
export const formatVAT = (vat?: number | string | null): string | undefined => {
    if (!vat) return undefined
    return vat.toString()
    // NOTE: We are now accepting VAT as a non-numeric string.
    // This may change in favor of more strict VAT validation.
    // const int = parseInt(vat.toString())
    // return !isNaN(int) ? Math.floor(int).toString() : undefined
}

/**
 * Force any number to the given decimal precision.
 * Trailing zeroes will not be removed.
 */
export const toDecimalPlaces = (value: number, decimals: number = DECIMAL_PLACES): number =>
    typeof decimals === 'number' ? parseFloat(value.toFixed(decimals)) : value

type UnitValue = undefined | number | string
export const formatUnit = (value: UnitValue, unit: string) =>
    value !== undefined ? `${value} ${unit}` : ''
export const mm = (value: UnitValue) => formatUnit(value, t('common_unit_mm'))
export const kN = (value: UnitValue) => formatUnit(value, t('common_unit_kn'))
export const kNmm = (value: UnitValue) => formatUnit(value, t('common_unit_kn_mm'))
export const ns = (value: UnitValue) => formatUnit(value, t('common_unit_ns'))
export const degreeC = (value: UnitValue) => formatUnit(value, t('common_unit_c'))
